export default class Mask {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        if(value.match(/^[a-zA-Z][0-9]/)) {
            return 'a9999aaa';
        }
        else {
            return '9999';
        }
    }

    birthdate() {
        return '39-19-2999';
    }
}
